import React from "react";
import AsyncCreatableSelect from 'react-select/async-creatable';
import { getCustomStyles } from "./field-themes";
import { classNames } from "../../common/util/util-helpers";

export default function FieldCreatableAsync({item, loadOptions, options, defaultOptions, onChange}) {
    if (!item.props) {
        item.props = {}
    }
    // const formatGroupLabel = data => (
    //     <div style={getSelectGroupStyles()}>
    //         <span>{data.label}</span>
    //         <span style={getSelectGroupBadgeStyles()}>{data.options.length}</span>
    //     </div>
    // );

    return (
        <React.Fragment>
            <AsyncCreatableSelect
                ref={item.props.innerRef}
                styles={getCustomStyles()}
                inputId={item.props.id ?? item.name}
                className={
                    classNames(item.props.className ?? "select-css-search p-0 form-control",
                        item.props.addClass
                    )
                }
                isDisabled={!!item.disabled}
                onChange={(selectedOption) => {
                    onChange(item.name, selectedOption);
                }}
                name={item.name}
                value={item.value}
                options={options}
                onCreateOption={
                    item.props.onCreateOption ?
                        (value) => item.props.onCreateOption(item.name, value) :
                        null
                }
                loadOptions={loadOptions}
                defaultOptions={!!defaultOptions}
                isClearable={!!item.props.isClearable}
                isMulti={item.props.isMulti}
                placeholder={!!item.props.placeholder ? item.props.placeholder : 'Select...'}
                //formatGroupLabel={formatGroupLabel}
                formatCreateLabel={!!item.props.formatCreateLabel ?
                    item.props.formatCreateLabel :
                    userInput => 'Create "' + userInput + '"'}
                menuPortalTarget={item.props.hasPortal ? document.body : null}
            />
        </React.Fragment>
    )
}
